import Image from 'next/image';
import IconImage from '@/images/branding/logo-icon-empire-nine.svg';
import '@/styles/components/ui/icon.css';

export default function Icon({alt}) {
  return (
    <Image
      src={IconImage.src}
      width={26}
      height={44}
      alt={alt}
      unoptimized={true}
      loading='eager'
      className="icon-main"
    />
  );
}
